import {
  type ClaimOfferInput,
  type ClickToClaimMachineInput,
} from '../click-to-claim.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const getClaimOfferInput: ClickToClaimMachineInput<ClaimOfferInput> = (args) => {
  return { offerId: args.context.offerId };
};
